/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { PagedResultDto_CompanyBankListDto } from '../models/PagedResultDto_CompanyBankListDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_BankAccountVerificationTypeDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_BankAccountVerificationTypeDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken';
import type { Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_SavePublicTokenMetaDataDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_SavePublicTokenMetaDataDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ManualBankAccountDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ManualBankAccountDto';
import type { Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto } from '../models/Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto';

import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class CompanyBankService {

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppCompanyBankLinkToken(): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/company-bank/link-token',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_BankAccountVerificationTypeDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppCompanyBankVerificationTypeList(): CancelablePromise<Array<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_BankAccountVerificationTypeDto>> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/company-bank/verification-type-list',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_SavePublicTokenMetaDataDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankSavePublicTokenMetaData(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_SavePublicTokenMetaDataDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_SavePublicTokenMetaDataDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/save-public-token-meta-data',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankMakeTaxAccount(
companyBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/make-tax-account/{companyBankId}',
            path: {
                'companyBankId': companyBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankMakeExerciseAccount(
companyBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/make-exercise-account/{companyBankId}',
            path: {
                'companyBankId': companyBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankMakeExerciseAndTaxAccount(
companyBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/make-exercise-and-tax-account/{companyBankId}',
            path: {
                'companyBankId': companyBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param filter 
     * @param sorting 
     * @param skipCount 
     * @param maxResultCount 
     * @returns PagedResultDto_CompanyBankListDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppCompanyBankCompanyBankList(
filter?: string,
sorting?: string,
skipCount?: number,
maxResultCount?: number,
): CancelablePromise<PagedResultDto_CompanyBankListDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/company-bank/company-bank-list',
            query: {
                'Filter': filter,
                'Sorting': sorting,
                'SkipCount': skipCount,
                'MaxResultCount': maxResultCount,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppCompanyBankCompanyBankForView(
companyBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_CompanyBankForViewDto> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/company-bank/company-bank-for-view/{companyBankId}',
            path: {
                'companyBankId': companyBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankVerifyManualBankAccount(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_SavePublicTokenMetaDataDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/verify-manual-bank-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken OK
     * @throws ApiError
     */
    public static getApiFinanceIntegrationApiAppCompanyBankLinkTokenForManualBankAccountVerification(
companyBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_CompanyBank_ResponseCreateLinkToken> {
        return __request(OpenAPI, {
            method: 'GET',
            url: '/api/finance-integration/api/app/company-bank/link-token-for-manual-bank-account-verification/{companyBankId}',
            path: {
                'companyBankId': companyBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param companyBankId 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static deleteApiFinanceIntegrationApiAppCompanyBankCompanyBankAccount(
companyBankId: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'DELETE',
            url: '/api/finance-integration/api/app/company-bank/company-bank-account/{companyBankId}',
            path: {
                'companyBankId': companyBankId,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param requestBody 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankRegisterManualBankAccount(
requestBody?: Wealthlane_FinanceIntegrationService_Dtos_ParticipantBank_ManualBankAccountDto,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/register-manual-bank-account',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

    /**
     * @param id 
     * @returns Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto OK
     * @throws ApiError
     */
    public static postApiFinanceIntegrationApiAppCompanyBankSetAccountAsDefaultAccount(
id: string,
): CancelablePromise<Wealthlane_FinanceIntegrationService_Dtos_Response_ResponseDto> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/finance-integration/api/app/company-bank/{id}/set-account-as-default-account',
            path: {
                'id': id,
            },
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
